import { useEffect, useState } from 'react';

// True on phone-width screens. Shared by the app shell (to lock the
// phone to Time & Expenses) and by pages that render a mobile layout.
export default function useIsMobile(query = '(max-width: 720px)') {
  const get = () => (typeof window !== 'undefined' && window.matchMedia)
    ? window.matchMedia(query).matches : false;
  const [m, setM] = useState(get);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia(query);
    const handler = () => setM(mq.matches);
    handler();
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else mq.addListener(handler);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', handler);
      else mq.removeListener(handler);
    };
  }, [query]);
  return m;
}
